declare global {
  interface Window {
    _paq: any
  }
}

window._paq = window._paq || {}

export default class mtm {
  public static sendEvent = (
    category: string,
    action: string,
    name?: string,
    value?: number | string,
  ): void => {
    const _paq = (window._paq = window._paq || [])
    _paq.push(['trackEvent', category, action, name ?? undefined, value ?? undefined])
  }
}
